import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between; /* Alinha os itens horizontalmente com espaço entre eles */
  align-items: center; /* Alinha os itens verticalmente ao centro */
  color: #a1a1a1;
  text-align: left;
  font: 500 11px 'Calibri';
  letter-spacing: 0.4px;
  opacity: 1;
  margin: 0 auto;
  max-width: 1038px;
  width: 100%;
  margin-top: 8%;
`;